import { z } from "zod";
import { TopolColorSchema } from "./commonSchema";

export const defaultStyle = {
  h1: {
    "font-family": "Helvetica, Arial, sans-serif",
    "font-size": "22px",
  },
  a: {
    color: "#0000EE",
  },
  h2: {
    "font-family": "Helvetica, Arial, sans-serif",
    "font-size": "17px",
  },
  h3: {
    "font-family": "Helvetica, Arial, sans-serif",
    "font-size": "13px",
  },
  p: {
    "font-family": "Helvetica, Arial, sans-serif",
    "font-size": "11px",
  },
  ul: {
    "font-size": "11px",
    "font-family": "Helvetica, Arial, sans-serif",
  },
  li: {
    "font-size": "11px",
    "font-family": "Helvetica, Arial, sans-serif",
  },
  ol: {
    "font-size": "11px",
    "font-family": "Helvetica, Arial, sans-serif",
  },
  ".rounded>table": {
    "border-collapse": "separate",
  },
};

export const topolStyleSchema = z.object({
  h1: z
    .object({
      "font-family": z.string().catch(defaultStyle.h1["font-family"]),
      "font-size": z.string().catch(defaultStyle.h1["font-size"]),
      color: TopolColorSchema.optional().catch(undefined),
      "font-style": z.string().optional().catch(undefined),
      "text-decoration": z.string().optional().catch(undefined),
      "font-weight": z.string().optional().catch(undefined),
      "text-transform": z.string().optional().catch(undefined),
      "letter-spacing": z.string().optional().catch(undefined),
      "line-height": z.number().optional().catch(undefined),
    })
    .catch(defaultStyle.h1),
  a: z
    .object({
      color: TopolColorSchema.catch(defaultStyle.a.color),
    })
    .catch(defaultStyle.a),
  h2: z
    .object({
      "font-family": z.string().catch(defaultStyle.h2["font-family"]),
      "font-size": z.string().catch(defaultStyle.h2["font-size"]),
      color: TopolColorSchema.optional().catch(undefined),
      "font-style": z.string().optional().catch(undefined),
      "text-decoration": z.string().optional().catch(undefined),
      "font-weight": z.string().optional().catch(undefined),
      "text-transform": z.string().optional().catch(undefined),
      "letter-spacing": z.string().optional().catch(undefined),
      "line-height": z.number().optional().catch(undefined),
    })
    .catch(defaultStyle.h2),
  h3: z
    .object({
      "font-family": z.string().catch(defaultStyle.h3["font-family"]),
      "font-size": z.string().catch(defaultStyle.h3["font-size"]),
      color: TopolColorSchema.optional().catch(undefined),
      "font-style": z.string().optional().catch(undefined),
      "text-decoration": z.string().optional().catch(undefined),
      "font-weight": z.string().optional().catch(undefined),
      "text-transform": z.string().optional().catch(undefined),
      "letter-spacing": z.string().optional().catch(undefined),
      "line-height": z.number().optional().catch(undefined),
    })
    .catch(defaultStyle.h3),

  p: z
    .object({
      "font-family": z.string().catch(defaultStyle.p["font-family"]),
      "font-size": z.string().catch(defaultStyle.p["font-size"]),
      color: TopolColorSchema.optional().catch(undefined),
      "font-style": z.string().optional().catch(undefined),
      "text-decoration": z.string().optional().catch(undefined),
      "font-weight": z.string().optional().catch(undefined),
      "text-transform": z.string().optional().catch(undefined),
      "letter-spacing": z.string().optional().catch(undefined),
      "line-height": z.number().optional().catch(undefined),
    })
    .catch(defaultStyle.p),

  ul: z
    .object({
      "font-size": z.string().catch(defaultStyle.ul["font-size"]),
      "font-family": z.string().catch(defaultStyle.ul["font-family"]),
      color: TopolColorSchema.optional().catch(undefined),
      "font-style": z.string().optional().catch(undefined),
      "text-decoration": z.string().optional().catch(undefined),
      "font-weight": z.string().optional().catch(undefined),
      "text-transform": z.string().optional().catch(undefined),
      "letter-spacing": z.string().optional().catch(undefined),
      "list-style-type": z.string().optional().catch(undefined),
      "margin-bottom": z.string().optional().catch(undefined),
      "margin-top": z.string().optional().catch(undefined),
      "padding-left": z.string().optional().catch(undefined),
    })
    .catch(defaultStyle.ul),

  li: z
    .object({
      "font-size": z.string().catch(defaultStyle.li["font-size"]),
      "font-family": z.string().catch(defaultStyle.li["font-family"]),
      color: TopolColorSchema.optional().catch(undefined),
      "font-style": z.string().optional().catch(undefined),
      "text-decoration": z.string().optional().catch(undefined),
      "font-weight": z.string().optional().catch(undefined),
      "text-transform": z.string().optional().catch(undefined),
      "letter-spacing": z.string().optional().catch(undefined),
      "line-height": z.number().optional().catch(undefined),
    })
    .catch(defaultStyle.li),

  ol: z
    .object({
      "font-size": z.string().catch(defaultStyle.ol["font-size"]),
      "font-family": z.string().catch(defaultStyle.ol["font-family"]),
      color: TopolColorSchema.optional().catch(undefined),
      "font-style": z.string().optional().catch(undefined),
      "text-decoration": z.string().optional().catch(undefined),
      "font-weight": z.string().optional().catch(undefined),
      "text-transform": z.string().optional().catch(undefined),
      "letter-spacing": z.string().optional().catch(undefined),
      "list-style-type": z.string().optional().catch(undefined),
      "margin-bottom": z.string().optional().catch(undefined),
      "margin-top": z.string().optional().catch(undefined),
      "padding-left": z.string().optional().catch(undefined),
    })
    .catch(defaultStyle.ol),

  ".rounded>table": z
    .object({
      "border-collapse": z
        .string()
        .catch(defaultStyle[".rounded>table"]["border-collapse"]),
    })
    .catch(defaultStyle[".rounded>table"]),
  "body>div": z
    .object({
      "background-image": z.string().optional().catch(undefined),
    })
    .optional()
    .catch(undefined),
});

export type TopolStyle = z.infer<typeof topolStyleSchema>;
